<block-ui [template]="loadingTemplate">
  <div id="app-main" class="app-main full-height" [ngClass]="{'fixed-header' : AppConfig.fixedHeader,
               'nav-collapsed' : AppConfig.navCollapsed,
               'nav-behind' : AppConfig.navBehind,
               'layout-boxed' : AppConfig.layoutBoxed,
               'theme-gray' : AppConfig.theme == 'gray',
               'theme-dark' : AppConfig.theme == 'dark',
               'theme-light' : AppConfig.theme == 'light',
               'theme-bradesco' : AppConfig.theme == 'bradesco',
               'sidebar-sm' : AppConfig.sidebarWidth == 'small',
               'sidebar-lg' : AppConfig.sidebarWidth == 'large',
               'right-panel-open' : rightPanelOpen}">
    <router-outlet></router-outlet>
  </div>
</block-ui>